export function sourceRegion(width, height, mode) {
  if (mode === "fit") return { sx: 0, sy: 0, sw: width, sh: height };
  const side = Math.min(width, height);
  return { sx: (width - side) / 2, sy: (height - side) / 2, sw: side, sh: side };
}

export function drawToCanvas(source, size, canvas = document.createElement("canvas"), mode = "center") {
  const width = source.videoWidth || source.naturalWidth || source.width;
  const height = source.videoHeight || source.naturalHeight || source.height;
  if (!width || !height) throw new Error("Sorgente immagine vuota");
  const { sx, sy, sw, sh } = sourceRegion(width, height, mode);
  canvas.width = size;
  canvas.height = size;
  const context = canvas.getContext("2d", { willReadFrequently: true });
  context.imageSmoothingQuality = "high";
  context.drawImage(source, sx, sy, sw, sh, 0, 0, size, size);
  return context.getImageData(0, 0, size, size);
}

export function letterbox(source, size, canvas = document.createElement("canvas"), fill = "#727272") {
  const width = source.videoWidth || source.naturalWidth || source.width;
  const height = source.videoHeight || source.naturalHeight || source.height;
  if (!width || !height) throw new Error("Sorgente immagine vuota");
  const scale = Math.min(size / width, size / height);
  const drawWidth = Math.max(1, Math.round(width * scale));
  const drawHeight = Math.max(1, Math.round(height * scale));
  const dx = Math.floor((size - drawWidth) / 2);
  const dy = Math.floor((size - drawHeight) / 2);
  canvas.width = size;
  canvas.height = size;
  const context = canvas.getContext("2d", { willReadFrequently: true });
  context.fillStyle = fill;
  context.fillRect(0, 0, size, size);
  context.imageSmoothingQuality = "high";
  context.drawImage(source, 0, 0, width, height, dx, dy, drawWidth, drawHeight);
  return { pixels: context.getImageData(0, 0, size, size), pad: { size, dx, dy, drawWidth, drawHeight, width, height } };
}

export function unpadBox(box, pad) {
  const clamp = (value) => Math.min(1, Math.max(0, value));
  return {
    ...box,
    x1: clamp((box.x1 * pad.size - pad.dx) / pad.drawWidth),
    y1: clamp((box.y1 * pad.size - pad.dy) / pad.drawHeight),
    x2: clamp((box.x2 * pad.size - pad.dx) / pad.drawWidth),
    y2: clamp((box.y2 * pad.size - pad.dy) / pad.drawHeight)
  };
}

export function toTensorData(imageData, mean, std) {
  const { data, width, height } = imageData;
  const plane = width * height;
  const out = new Float32Array(3 * plane);
  for (let i = 0; i < plane; i += 1) {
    const offset = i * 4;
    out[i] = (data[offset] / 255 - mean[0]) / std[0];
    out[plane + i] = (data[offset + 1] / 255 - mean[1]) / std[1];
    out[2 * plane + i] = (data[offset + 2] / 255 - mean[2]) / std[2];
  }
  return out;
}

export function snapshotJpeg(source, maxSide = 768, quality = 0.82) {
  const width = source.videoWidth || source.naturalWidth || source.width;
  const height = source.videoHeight || source.naturalHeight || source.height;
  const scale = Math.min(1, maxSide / Math.max(width, height));
  const canvas = document.createElement("canvas");
  canvas.width = Math.round(width * scale);
  canvas.height = Math.round(height * scale);
  canvas.getContext("2d").drawImage(source, 0, 0, canvas.width, canvas.height);
  return canvas.toDataURL("image/jpeg", quality);
}

export function squareSnapshot(source, size = 640, quality = 0.85) {
  const width = source.videoWidth || source.naturalWidth || source.width;
  const height = source.videoHeight || source.naturalHeight || source.height;
  const { sx, sy, sw, sh } = sourceRegion(width, height, "center");
  const canvas = document.createElement("canvas");
  const side = Math.min(size, sw);
  canvas.width = side;
  canvas.height = side;
  canvas.getContext("2d").drawImage(source, sx, sy, sw, sh, 0, 0, side, side);
  return canvas.toDataURL("image/jpeg", quality);
}

export function framingSnapshot(source, mode, size = 640) {
  return mode === "center" ? squareSnapshot(source, size) : snapshotJpeg(source, size, 0.85);
}
